module.exports = new __parcel__URL__("gtk-logo.f835404e.jpeg").toString();